export default {"src":"/_next/static/media/rotate.a30923eb.svg","height":30,"width":26};